// route-error.tsx — a render-hibák hálója (audit T15): enélkül egy komponens-hiba üres fehér
// oldalt ad, kiút nélkül. Szándékosan primitív: ha idáig jutottunk, minél kevesebb kódtól függjön.
import { useTranslation } from 'react-i18next';

export function RouteError({ error }: { error: unknown }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="mx-auto mt-24 max-w-md text-center">
      <h1 className="text-xl font-semibold">{t('errorPage.title')}</h1>
      <p className="text-muted-foreground mt-2 text-sm">{t('errorPage.body')}</p>
      <pre className="text-subtle mt-4 overflow-x-auto text-xs">{String(error)}</pre>
      <button
        type="button"
        className="text-primary mt-6 underline"
        onClick={() => {
          window.location.assign('/');
        }}
      >
        {t('errorPage.home')}
      </button>
    </div>
  );
}
